import React from 'react';
import { Grid, Card, CardContent, Typography, useTheme } from '@mui/material';
import TemplateEffectivenessInsightCard from './TemplateEffectivenessInsightCard';
import PropTypes from 'prop-types';

/**
 * TemplateEffectivenessSection Component
 * Special section for template effectiveness insights with accordion cards
 */
const TemplateEffectivenessSection = ({ insights }) => {
  const theme = useTheme();

  if (!insights || insights.length === 0) {
    return null;
  }

  return (
    <Grid item xs={12} sx={{ display: 'flex' }}>
      <Card
        sx={{
          borderRadius: '10px',
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
          boxShadow: 'none',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <CardContent
          sx={{
            p: 2.5,
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: theme.palette.text.primary,
              mb: 2,
              fontSize: '0.9375rem',
              letterSpacing: '-0.01em',
            }}
          >
            Template Effectiveness Insights
          </Typography>
          <Grid
            container
            spacing={2}
            sx={{
              alignItems: 'stretch',
              width: '100%',
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                md: 'repeat(2, 1fr)',
              },
              gap: 2,
              '& > .MuiGrid-item': {
                display: 'flex',
                minHeight: '240px',
                width: '100%',
              },
            }}
          >
            {insights.map((insight, index) => (
              <Grid
                item
                xs={12}
                md={6}
                key={index}
                sx={{
                  display: 'flex',
                  alignItems: 'stretch',
                  minWidth: 0,
                  width: '100%',
                }}
              >
                <TemplateEffectivenessInsightCard insight={insight} />
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

TemplateEffectivenessSection.propTypes = {
  insights: PropTypes.array.isRequired,
};

export default TemplateEffectivenessSection;
